import { UserReward } from './UserReward';

export enum LootBoxType {
  Bronze = 'bronze',
  Silver = 'silver',
}

export interface UserLootBox {
  type: LootBoxType;
  rewards: UserReward[];
}
